import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export var FLASH_TIMER = 100;
export var FAST_TIMER = 300;
export var TIMER = 500;
export var SLOW_TIMER = 1000;